import { DetailedMatch } from "@/data/match";
import { useBackendQueryFunction } from "@/hooks/common/useBackendQueryFunction";
import { UrlQuery } from "@/hooks/common/useBackendUrl";
import { GetMatchesKey } from "@/hooks/match";
import { useState } from "react";
import { useQuery } from "react-query";

interface UseGetMatchProps extends UrlQuery {
  id: string;
}

export function useGetMatch(props: UseGetMatchProps) {
  const [shouldRefetch, setShouldRefetch] = useState(false);
  const queryFn = useBackendQueryFunction<DetailedMatch>(
    "/internal/match/:id",
    props
  );

  return useQuery<DetailedMatch>([GetMatchesKey, props], queryFn, {
    refetchInterval: shouldRefetch ? 15000 : false,
    onSuccess: (match) => {
      if (match.matchState === "Active" && !shouldRefetch) {
        setShouldRefetch(true);
      } else if (match.matchState !== "Active" && shouldRefetch) {
        setShouldRefetch(false);
      }
    },
  });
}
